import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, productImageAlt } from '../data/offer';
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-navy-950" data-id="element-85" data-mp="4njq6ckn7zc1">
      <div className="flex h-1 w-full" aria-hidden="true" data-id="element-86" data-mp="128fnvds7g3t2">
        <span className="flex-1 bg-steel" data-id="element-87" data-mp="xano5xlbjdeb" />
        <span className="w-24 bg-copper" data-id="element-88" data-mp="xbpaiy7sbmbc" />
        <span className="flex-1 bg-steel" data-id="element-89" data-mp="x8jj3cboo8cg" />
      </div>

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-90" data-mp="s9zwrat6gujk">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-copper/50 bg-navy-900 px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-white" data-id="element-91" data-mp="nb6mrsd3nlo5">
          <ZapIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-92" data-mp="3o7c1q2dl4xiq" /> Power Distribution &amp; Switchgear · Professional Edition
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-93" data-mp="39a362wh917l7">
          <img src={productImage} alt={productImageAlt} className="mx-auto w-full drop-shadow-[0_0_36px_rgba(242,193,78,0.3)]" data-id="element-94" data-mp="359szbhlmud5a" />
        </motion.div>

        <div className="mt-9" data-id="element-95" data-mp="2qi0lxb5ef967">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-96" data-mp="2viermmjj2712">
            Get your professional edition now
          </Button>
        </div>
      </div>
    </section>;
}